import { render, staticRenderFns } from "./settlementDetails.vue?vue&type=template&id=61cd6736&scoped=true"
import script from "./settlementDetails.vue?vue&type=script&lang=js"
export * from "./settlementDetails.vue?vue&type=script&lang=js"
import style0 from "./settlementDetails.vue?vue&type=style&index=0&id=61cd6736&prod&lang=scss"
import style1 from "./settlementDetails.vue?vue&type=style&index=1&id=61cd6736&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cd6736",
  null
  
)

export default component.exports